import { ABP, SettingTabsService } from '@abp/ng.core';
import { Component, OnDestroy, OnInit, TrackByFunction } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import { LayoutState } from '../../../states/layout.state';
import { SetSelectedSettingTab } from '../../../actions/layout.actions';

@Component({
	selector: 'hedou-setting-management',
	templateUrl: './setting-management.component.html',
	styleUrls: ['./setting-management.component.less']
})
export class SettingManagementComponent implements OnDestroy, OnInit {

	private subscription = new Subscription();
	settings: ABP.Tab[] = [];


	set selected(value: ABP.Tab) {
		this.store.dispatch(new SetSelectedSettingTab(value));
	}
	
	get selected(): ABP.Tab {
		const value = this.store.selectSnapshot(LayoutState.getSelectedTab);
		return value?.component ? value : this.settings[0] || ({} as ABP.Tab);
	}

	constructor(private store: Store, private settingTabsService: SettingTabsService) { }

	trackByFn: TrackByFunction<ABP.Tab> = (_, item) => item.name;

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	ngOnInit() {
		this.subscription.add(
			this.settingTabsService.visible$.subscribe(settings => {
				this.settings = settings;
				console.log('setting 改变了')
				// if (!this.selected) this.selected = this.settings[0];
			}),
		);
	}
}
